"use strict";

angular.module('app.controllers.errorLog', [])

.config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('errorHandling', {
        parent: 'site',
        url: '/errorLog/:bundleId/:errorId',
        controller: 'errorLogCtrl',
        template: '{{error}}',
        breadcrumb: {
            ignore: true
        },
        resolve: {
            ErrorItem: function ($stateParams, _err) {
                'ngInject';

                return _err.get($stateParams.bundleId, $stateParams.errorId-1);
            }
        }
    });
}])

.controller("errorLogCtrl", ['ErrorItem', '$scope',
    function (ErrorItem, $scope) {
        $scope.error = ErrorItem;
    }
]);
